export const PLAYER_TRANSLATIONS = {
	audio: 'Audio',
	audioSubtitlesAndCCLabel: 'Audio/Subtitles/Closed Captions (c)',
	closedCaptions: 'Closed Captions',
	dualPlaybackLayoutViews: 'Layout Views (d)',
	fullScreenEnd: 'End Full Screen ( f )',
	fullScreenStart: 'Activate Full Screen ( f )',
	fullViewContent: 'Full View Content',
	fullViewSpeaker: 'Full View Speaker',
	live: 'Live',
	loadingPlugin: 'Loading plugin...',
	mute: 'Mute ( m )',
	muted: 'Muted',
	off: 'Off',
	ok: 'OK',
	pause: 'Pause ( k )',
	play: 'Play ( k )',
	playback360NotSupported: '360 video playback is not supported on this browser',
	playbackMenu: 'Playback Menu',
	playbackNotAvailable: 'Playback of this video is not available. Please try again later. If the problem persists, please contact your administrator.',
	playbackNotSupported: 'Playback of this video is not currently supported on this browser',
	reset360: 'Reset',
	restart: 'Restart',
	resume: 'Resume',
	revConnectMeshFull:
		'All available peer meshes are full. Player cannot join Rev Connect peer mesh.',
	scrubBar: 'Time scrub bar',
	sideBySide: 'Side-by-side',
	speakerBottomRight: 'Speaker on the bottom-right',
	speakerTopRight: 'Speaker on the top-right',
	stop: 'stop',
	subtitles: 'Subtitles',
	unmute: 'Unmute ( m )',

	//newly added.
	playerSettingsMenu: 'Settings ( s )',
	playbackSpeed: 'Playback speed',
	normal: 'Normal',
	notVerified: "This video's source has not been verified.",
	playbackSource: 'Playback source',
	skipBack10Sec: 'Back 10 Secs ( j )',
	skipForward10Sec: 'Forward 10 Secs ( l )',
	trueView: 'TrueView',
	trueViewVerified: 'TrueView Verified',
	volumeLevel: 'Volume Level',
	watchAnyway: 'Watch Anyway',

	//hot keys
	hkPlayPause: 'Play / Pause ( k )',
	hkMuteUnmute: 'Mute / Unmute ( m )',
	hkStartEndFullScreen: 'Full Screen Start/End ( f )',
	keyboardShortcuts: 'Keyboard Shortcuts',

	reactions: 'Reactions',
	showHideReactions: 'Show or hide emojis over my video',
	reactionsTimeout: 'Please wait for reactions to be available again.',
	show: 'show',
	hide: 'hide',

	c2paClickToViewDetails: 'Click to view Content Credential details',
	viewMore: 'View More',
	c2paValid: 'Content Credentials Valid',
	c2paInvalid: 'Content Credentials Invalid',
	c2paIssuedBy: 'Issued by',
	c2paIssuedOn: 'Issued on',
	c2paContentCredentials: 'Content Credentials',
	c2paTooltip:
		'Content Credentials provide a traceable provenance, or history, of digital assets. This can help verify authenticity and build trust by showing who created it and how it was made. See contentcredentials.org for additional details.',
	invalid: 'Invalid',
};
